import HrSftpIntegrationPage from './HrSftpIntegrationPage';
export default HrSftpIntegrationPage;